<template>
  <div class="row m-0">
    <div class="col-12 p-0 my-3">
      <button @click="downloadCSVData()">Download Customers</button>
    </div>
    <div class="col-12 p-0 my-3">
      <div class="row">
        <div class="col">
          <div class="card hover w-100">
            <div class="card-body">
              <div class="row mx-0 my-3 align-items-center">
                <div class="col-12 p-0">
                  <h5 class="card-title text-center">
                    Best Customer
                  </h5>
                </div>
                <div class="col-12 p-0 text-center">
                  {{ bestCustomer.firstname }} {{ bestCustomer.lastname }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card hover w-100">
            <div class="card-body">
              <div class="row mx-0 my-3 align-items-center">
                <div class="col-12 p-0">
                  <h5 class="card-title text-center">
                    Total Customers
                  </h5>
                </div>
                <div class="col-12 p-0 text-center">
                  {{ salesByCustomer.length }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card hover w-100">
            <div class="card-body">
              <div class="row mx-0 my-3 align-items-center">
                <div class="col-12 p-0">
                  <h5 class="card-title text-center">
                    Average Customer Value
                  </h5>
                </div>
                <div class="col-12 p-0 text-center">
                  R {{ averageSale }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 p-0 my-3">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Email</th>
            <th scope="col">Firstname</th>
            <th scope="col">Lastname</th>
            <th scope="col"># Orders</th>
            <th scope="col">Total Order Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, key) in salesByCustomer" :key="key">
            <th scope="row">{{row.email}}</th>
            <td>{{row.firstname}}</td>
            <td>{{row.lastname}}</td>
            <td>{{row.sales.length}}</td>
            <td>R {{row.lifetimevalue}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <data-table :data="stateTableData" :tableProps="tableProps"></data-table> -->
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { DateTime } from 'luxon'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
export default {
  name: 'report',
  data: function () {
    return {
    }
  },
  filters: {
    showDate (date) {
      return DateTime.fromMillis(date).toLocaleString(DateTime.DATE_MED)
    }
  },
  computed: {
    ...mapGetters(['reportData']),
    bestCustomer () {
      let arr = [...this.salesByCustomer]
      arr.sort((a, b) => b.lifetimevalue - a.lifetimevalue)
      return arr[0]
    },
    averageSale () {
      let arr = [...this.salesByCustomer]
      let total = arr.reduce((total, row) => total + row.lifetimevalue, 0)
      return (total / this.salesByCustomer.length).toFixed(0)
    },
    paidSales () {
      return this.reportData.filter(sale => {
        return (sale.paid === true && DateTime.fromMillis(sale.status[0].startTime) >= this.dateRange.startDate && sale.status[0].startTime <= this.dateRange.endDate)
      })
    },
    salesByCustomer () {
      const sales = this.reportData.reduce((groups, order) => {
        if (order.paid === true) {
          if (typeof order.customer.uid !== 'undefined') {
            if (!groups[order.customer.uid]) {
              groups[order.customer.uid] = []
            }
            groups[order.customer.uid].push(order)
          }
        }
        return groups
      }, {})
      const salesArray = Object.keys(sales).map((uid) => {
        let ltv = 0
        sales[uid].forEach((sale) => {
          ltv += Number(sale.details.totalCost)
        })
        return {
          ...sales[uid][0].customer,
          sales: sales[uid],
          lifetimevalue: ltv
        }
      })
      salesArray.sort((a, b) => a.email.localeCompare(b.email))
      return salesArray
    }
  },
  mounted () {
    this.getReport()
  },
  methods: {
    ...mapActions(['getReport']),
    downloadCSVData () {
      let csv = 'Email,Firstname,Lastname,# Orders,Total Order Amount,\n'
      this.salesByCustomer.forEach((row) => {
        csv += `${row.email}, ${row.firstname}, ${row.lastname}, ${row.sales.length}, R ${row.lifetimevalue}`
        csv += '\n'
      })
      let anchor = document.createElement('a')
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
      anchor.target = '_blank'
      anchor.download = 'report.csv'
      anchor.click()
    }
  }

}
</script>

<style scoped>
  .date_picker.large {
    height: 56px !important;
    width: max-content;
    padding: 1rem 0.5rem;
    border: 2px solid orange;
  }
</style>
